import { Currency, HYDRA, Token } from 'hydra/sdk'

export function currencyId(currency: Currency): string {
  if (currency === HYDRA) return 'HYDRA'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
